/**
 * How long the AI review panel's "Generating comments" step should last, before
 * the random jitter the panel adds on top. Scales from a 10s base plus one second
 * per three seconds of video (or per review file, one when unknown), held
 * between a 20s floor and a 45s ceiling.
 */
export function generatingCommentsDurationMs(
  videoDurationSeconds: number | undefined,
  reviewFileCount: number | undefined,
): number {
  const base =
    10_000 +
    (videoDurationSeconds ? videoDurationSeconds / 3 : (reviewFileCount ?? 1)) *
      1000;
  return Math.min(45_000, Math.max(20_000, base));
}
